import React from "react";

export default function DynamicLabel({
  factupdate,
  language,
  locale,
  keyData,
  data,
  showLabel = true,
}) {
  return (
    <>
      {factupdate ? (
        language[locale][keyData] !== "" &&
        language[locale][keyData] !== undefined ? (
          <div className="row">
            {showLabel ? (
              <span className="col col-4 content-label">
                {language[locale][keyData]}
              </span>
            ) : null}
            <span className="col col-8 content-text">
              {data["data"] !== undefined ? data["data"] : null}
            </span>
          </div>
        ) : null
      ) : null}
    </>
  );
}
